import React from "react";
import NewsLetterAreaConfirm from "./NewsLetterAreaConfirm";

function SubscribeConfirm(props) {
    const { item_id } = props.match.params;
  return (
    <>
      <NewsLetterAreaConfirm item_id={item_id}  />
    </>
  );
}

export default SubscribeConfirm;
